module.exports = __webpack_public_path__ + "static/w-jilan-1740d0538c8ae291436e5941a1f3d849.jpeg";